export const totalRatingsTemplate = (
  countByRatingPosition: number,
  percentage: string
) => {
  return `${percentage}% (${countByRatingPosition})`
}
